import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toLocalISOString } from 'utils/date';

/**
 * req.body Date objects are processed with toISOString() before to be sent to the server
 * toISOString() is applying UTC offset, thus no additional date offsetting required
 *
 * IMPORTANT: All Date objects in GET params must be processed with toISOString()
 */
@Injectable({
    providedIn: 'root'
})
export class DateInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Temprorarily using preprocess method
        req = req.clone({
            body: this.preProcessDates(req.body)
        });

        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.postProcessDates(event.body);
                    return event;
                }
            })
        );
    }

    /**
     * PreProcessing Dates
     *
     * This is a temprorarily method and must be removed when server handles UTC dates propertly
     *
     * Converting Dates to ISO 8601 string without timezone offset
     */
    private preProcessDates(obj: any): any {
        if (obj === null || obj === undefined) {
            return obj;
        }

        if (typeof obj !== 'object') {
            return obj;
        }

        for (const key of Object.keys(obj)) {
            const value = obj[key];

            if (value instanceof Date) {
                obj[key] = toLocalISOString(value);
            } else if (typeof value === 'object') {
                this.preProcessDates(value);
            }
        }
    }

    /**
     * PostProcessing Dates
     *
     * Converting UTC to Local Date
     *
     * Date must be in ISO 8601 format
     */
    private postProcessDates(obj: any): any {
        if (obj === null || obj === undefined) {
            return obj;
        }

        if (typeof obj !== 'object') {
            return obj;
        }

        for (const key of Object.keys(obj)) {
            const value = obj[key];
            const iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

            if (iso8601.test(value) === true) {
                // Uncomment this later on
                // obj[key] = this.localDateFromUTC(new Date(value));
                obj[key] = new Date(value);
            } else if (typeof value === 'object') {
                this.postProcessDates(value);
            }
        }
    }

    // private localDateFromUTC(date: Date): Date {
    //     return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    // }
}
